import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { useAutomationMenu } from '../../menu-context';
var i18n = defineMessages({
  ruleExecutionSuccessMessage: {
    id: 'automation-menu.success-state.message',
    defaultMessage: 'Your automation is in progress',
    description: 'Message that is displayed when a users automation rule has been successfully queued.'
  },
  ruleExecutionErrorMessage: {
    id: 'automation-menu.modal.error.description',
    defaultMessage: 'Oops we ran into a problem',
    description: "Description for the error section shown when rules can't be executed"
  }
});
var messageStyling = xcss({
  marginInline: 'space.300',
  marginTop: 'space.100',
  // The ModalFooter comes with a lot of built in margin, want to nudge the error message in to the footer a bit
  marginBottom: 'space.negative.100'
});
export var AutomationModalExecutionState = function AutomationModalExecutionState() {
  var _useAutomationMenu = useAutomationMenu(),
    ruleExecutionState = _useAutomationMenu.ruleExecutionState;
  if (ruleExecutionState === 'FAILURE') {
    return /*#__PURE__*/React.createElement(Box, {
      xcss: messageStyling
    }, /*#__PURE__*/React.createElement(SectionMessage, {
      appearance: "error"
    }, /*#__PURE__*/React.createElement(FormattedMessage, i18n.ruleExecutionErrorMessage)));
  } else {
    return null;
  }
};